var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.sharkCarHeaders,"items":_vm.golfCarData,"loading":_vm._loading,"footer-props":{
    'items-per-page-options': [50, 100, 150],
  },"server-items-length":_vm.total,"options":_vm.options},on:{"update:options":[function($event){_vm.options=$event},function($event){return _vm._getReportInstances(_vm.options)}],"click:row":_vm.goTo},scopedSlots:_vm._u([{key:"item.network_status",fn:function(ref){
  var item = ref.item;
return [_c('v-icon',{attrs:{"color":item.network_status,"x-large":""}},[_vm._v(" mdi-circle-medium")])]}},{key:"item.launch_mode",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatLaunchMode(item.launch_mode))+" ")]}},{key:"item.last_activity",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.last_activity))+" ")]}},{key:"item.group_name",fn:function(ref){
  var item = ref.item;
return [_c('div',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(item.group_name)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }